import axios from 'axios';
import { errorResponseInterceptor, tokenRequestInterceptor } from './apiTools';

const DOMAIN = process.env.REACT_APP_DOMAIN ?? '';

const api = axios.create({
  baseURL: DOMAIN,
});

api.interceptors.request.use(tokenRequestInterceptor);

api.interceptors.response.use((response) => {
  const { isFullData } = response.config;

  if (isFullData) {
    return response;
  }

  return response.data;
}, errorResponseInterceptor);

export { api };
